import React, { FC } from 'react';
import { Box, Grid } from '@material-ui/core';
import clsx from 'clsx';
import BanIcon from '../../../../../../gqlCommon/components/BanIcon';
import IFeature from '../../../../../model/IFeature';
import featureColorStyles from './featureColorStyles';
import { IDisplayVariantType } from '../../../../../enum/IDisplayVariantType';
import ICategoryAttributes from '../../../../../model/ICategoryAttributes';
import featuresPerRowService from '../../../../../service/featuresPerRowService';

export interface IFeatureProps {
  feature: IFeature;
  id: string;
  onClick?: (id: string, categoryPurpose?: string, featureName?: string) => void;
  selectedCode: string;
  isDisabled?: boolean;
  variant?: string;
  categoryAttributes?: ICategoryAttributes;
}

const FeatureColor: FC<IFeatureProps> = ({
  feature,
  onClick,
  selectedCode,
  isDisabled,
  id,
  variant,
  categoryAttributes,
}) => {
  const styles = featureColorStyles();
  const hexColourCode = feature.attributes.hexColourCode ?? null;
  const colorImageSource = feature.images[0]?.url ?? null;
  const numberofitemsperrow = categoryAttributes?.numberofitemsperrow;
  const gridSize = featuresPerRowService.getFeaturesPerRow(numberofitemsperrow);

  return (
    <Grid item={true} xs={gridSize ?? 'auto'} className={styles.container} data-test={`option:type:color:${id}`}>
      {isDisabled && <BanIcon data-test="button:color_picker:disabled" className={styles.banIcon} />}
      <Box
        aria-disabled={isDisabled}
        onClick={() => onClick(id, categoryAttributes?.categorypurpose, feature?.name)}
        className={clsx([
          styles.color,
          { [styles.activeColor]: selectedCode === id && !isDisabled },
          { [styles.disabled]: isDisabled },
          { [styles.smallColor]: variant === IDisplayVariantType.SMALL },
        ])}
        boxShadow={selectedCode ? 1 : 0}
        style={{
          background: hexColourCode ? `#${hexColourCode}` : colorImageSource && `url(${colorImageSource}) center`,
        }}
        data-test={`option:type:${hexColourCode ? 'hex_color' : 'image'}`}
      >
        {selectedCode === id && !isDisabled && (
          <Box
            data-test="button:color_picker:active"
            className={variant === 'small' ? styles.smallBorder : styles.activeColorBorder}
          />
        )}
      </Box>
    </Grid>
  );
};

export default FeatureColor;
